import { Trans } from "@lingui/react";
import { WIcon } from "@mobility-item-page/client";
import { Button } from "@warp-ds/react";
import { ScreenReaderSeparator } from "../components/ScreenReaderSeparator.tsx";
import { useValidDealerItemContext } from "../context/DealerItemProviderContext.tsx";
import { useTracking } from "../utils/pulseHelper.ts";

export const DeepLinkAction = () => {
  const {
    itemData: { externalItemUrl },
    external: { isPreview },
  } = useValidDealerItemContext();
  if (externalItemUrl) {
    return <ExternalItem key="external" externalItemUrl={externalItemUrl} isPreview={isPreview} />;
  }
  return null;
};

const ExternalItem = ({ externalItemUrl, isPreview = false }: { externalItemUrl: string; isPreview?: boolean }) => {
  const { trackGoToItem } = useTracking();

  if (isPreview) {
    return (
      <Button data-testid="external-item" fullWidth className="flex items-center whitespace-nowrap md:min-w-[170px]">
        <Trans id="dealer.actions.deeplink" message="View ad on seller's page" />
        <ScreenReaderSeparator />
        <WIcon name="LinkExternal" className="ml-4" />
      </Button>
    );
  }

  return (
    <Button
      data-testid="external-item"
      fullWidth
      className="flex items-center whitespace-nowrap md:min-w-[170px]"
      href={externalItemUrl}
      target="_blank"
      rel="noopener sponsored"
      onClick={trackGoToItem}
    >
      <Trans id="dealer.actions.deeplink" message="View ad on seller's page" />
      <ScreenReaderSeparator />
      <WIcon name="LinkExternal" className="ml-4" />
    </Button>
  );
};
